<template>
  <article class="article">
    <div v-if="!isAuditing">
      <p class="fwbd tc mt20">点点平台授权及协议须知</p>

      <p>申请使用“点点平台服务”，您需要详细阅知并同意本须知及相关协议的所有内容，如您不同意相关协议的任何条款，请停止使用“点点平台”服务：</p>

      <p>1.您使用“点点平台”服务，您须与深圳蜂点科技有限公司（以下简称“蜂点科技”或服务商）和众安在线财产保险股份有限公司(以下简称众安保险 )签订《“点点平台”用户服务协议》，并授权众安保险向中国人民银行及其他合法征信机构(以下合称“征信机构”)查询您的个人信用信息，用于评估服务商与您的交易条件和控制服务中的风险。</p>

      <p>2、有效期至您实际与“点点平台”服务商签订的《“点点平台”用户服务协议》规定的双方权利义务完全终止之日止。</p>

      <p>3、服务商将根据您的授权及委托，即对您的用户信息进行采集、整理、加工、保存，并向征信机构提供该等用户信息或基于该等用户信息加工、整理的信息，征信机构结合该等信息与其他因素，自行判断您的信用水平和/或相关风险，从而将输出结果告知服务商，由服务商决定其与您的交易条件或做出其他与您使用本服务相关的决策，具体的个人信用信息查询及结果反馈形式以实际提供的为准。</p>

      <p>4、为了保护您的合法权益，服务商不会采集您(作为个人用户)的宗教信仰、基因、指纹、血型、疾病和病史信息以及法律、行政法规规定禁止采集的其他个人信息。</p>

      <p>5、服务商或其合作方有权根据您的授权及委托，直接或指定合作的第三方支付清算公司 (以下简称第三方支付机构)或银行从您的任何一个或多个资金账户(包括但不限于点点平台账户、与点点平台账户绑定的储蓄卡账户等各类账户)中扣除相应款项用于偿还您在服务项下到期债务（包括但不限于应付账款本金、逾期违约金等），直至债务清偿完毕为止，具体授权内容请见服务页面中的相关协议。</p>

      <p><b>“点点平台”用户服务协议</b></p>

      <p><b>合同编号：</b></p>

      <p><b>特别提醒：在您确认签署本协议之前，请您务必仔细阅读本协议所有条款，尤其是以粗体或下划线标准的条款，签署条款含有免除或限制协议其他方责任的内容。一旦您点击“同意”、“立刻开通”、“确认”等表示认可的按钮确认使用“点点平台”用户服务(以下简称“本服务”)，即意味您已充分理解本协议所有条款的含义及相应的法律后果，同意与本协议其他方通过网络订立本协议并接受本协议约束。本协议的缔约方除您之外，其他方包括：深圳蜂点科技有限公司（以下简称服务商）、众安在线财产保险股份有限公司。</b></p>

      <p>第一条 基本信息</p>

      <p>为了保护您的个人信息，本协议在向您展示时将部分隐藏您的部分身份信息，您的身份信息以您的【点点平台账户】对应的实名信息为准。</p>

      <p>用户姓名：【】</p>

      <p>身份证号码：【_*****************_】</p>

      <p>联系方式：【】</p>

      <p>协议生效要件：本协议自【您首次开通本服务/服务商审核通过】之时生效。</p>

      <p>第二条 术语定义</p>

      <p>除非本协议正文另有明确所指，在本协议中所用下列术语定义如下：</p>

      <p>1. 用户：指在“点点平台”上开设实名认证账户，且符合点点平台业务使用规则及本协议要求，使用本服务的自然人，以下称“您”或“用户”。</p>

      <p>2. 资金方：为点点平台服务提供借款资金的合法放贷机构。</p>

      <p>3. “点点平台”服务或本服务：指服务商向您提供的用于借款的相关金融信息服务。服务商有权不时调整该服务的营销推广名称。若营销推广名称有所调整，以点点平台官方APP公布的为准，不影响本协议的有效性和对各方的约束。</p>

      <p>4. “点点平台”账户：指您根据与服务商签订的《用户注册协议》，注册并认证成功后取得的实名认证账户。</p>

      <p>5. 最高承保额度：指根据您的基本信息由众安保险对您的信用情况进行审核后，众安保险对您通过点点平台进行借款所产生的个人消费贷款本息可进行承保的最高额度。</p>

      <p>6. 分期本金：指您使用“点点平台”服务对应的分期本金金额合计。</p>

      <p>7. 到期还款日：指您应将当月分期金额全部还清的最晚日期。如您未能最迟于到期还款日全额清偿当期全部应还款金额，将视为您逾期。</p>

      <p>8. 应还款金额：指您在提交还款时应支付的全部金额，包含分期本金、分期应还款项（如有）、利息、逾期违约金(如有)和其他款项(如有)的金额总额。</p>

      <p>9. 逾期违约金：指在您未能于到期还款日前支付全部到期应还款而导致违约时，服务商有权在向资金方赔付后按日就您当期仍未清偿的应还款项收取的违约金，直至您的到期应还款清偿完毕。</p>

      <p>10. 用户个人信息：指您在申请开通及使用“点点平台”服务时依据网站要求所提供的法律规定的个人身份信息，包括但不限于姓名、证件号、联系地址、手机号码等。</p>

      <p>第三条 信用保证保险</p>

      <p>该保险为众安保险推出的一款互联网信用保证保险产品，针对您的资金需求，为您提供方便快捷的保险服务。您作为借款申请人在资金方申请借款成功后，众安保险为该笔借款承保信用保证保险，如您在规定期限内未履行还款义务，则众安保险将您未履行还款义务部分的损失赔付给资金方，众安保险在赔付完成后有权就赔付款项向您进行追偿。并且，众安保险有权向中国人民银行征信系统及其他合法征信机构披露您的相关信息。</p>

      <p>第四条 服务费</p>

      <p>1. 在您使用本服务时，服务商有权向您收取服务费用。服务费按照消费本金的一定比例收取，根据分期的期数不同，手续费收取比例不同。</p>

      <p>2. 逾期利息：无论分期还款还是全额还款，若您在到期还款日仍未清偿当月应还的消费本金及当月分期应还款项，资金方将按每日未偿消费本金和及当月分期应还款项的余额的一定比例逐日计收逾期利息，直至您的消费本金及当月分期应还款项清偿完毕。在服务商向资金方赔付后，服务商即取得对您的代位追偿权，有权向您收取前述逾期利息。</p>

      <p>第五条 还款</p>

      <p>(一) 还款方式</p>

      <p>1. 使用“点点平台”服务申请借款成功后，应当在到期还款日23：00点前完成应还款金额支付。</p>

      <p>2. 您偿还应还款金额时可在“点点平台”进行操作。</p>

      <p>3. 若您未能在到期还款日23：00点前支付全部应还款金额而导致逾期时，资金方或代偿方有权自到期还款日次日起向您按日收取逾期违约金。</p>

      <p>(二) 还款提醒</p>

      <p>&gt;【服务商】可在到期还款日前以向您的手机号码发送短信、站内信、自动电子语音、人工电话提醒等形式提醒您按时还款。</p>

      <p>第六条 违约及违约处理</p>

      <p>(一) 违约情形</p>

      <p>您发生下列任一情况，均构成违约：</p>

      <p>1. 您未按本协议规定按时足额支付应还款金额。</p>

      <p>2. 您向服务商提供任何过期或虚假的信息或任何信息被服务商认为是可疑、过期或虚假信息。</p>

      <p>3. 您被宣告失踪、宣告死亡、处于限制民事行为能力或丧失民事行为能力状态、承担刑事责任。</p>

      <p>4. 您发生重大疾病、重大事故等可能影响付款能力的情况。</p>

      <p>5. 您以任何方式允许或者默许本人之外任何其他方使用“点点平台”服务。</p>

      <p>6. 您的资信情况出现其他重大不利变化导致您无法继续按时足额支付应付款的情形。</p>

      <p>7. 您存在欺诈行为的。</p>

      <p>8. 违反本协议约定的其他义务。</p>

      <p>(二) 违约处理</p>

      <p>如出现上述违约情形，或违背本协议项下其他任何义务、陈述、保证或承诺的，服务商有权采取下列一项或多项措施，包括但不限于：</p>

      <p>1. 调整或取消您的最高承保额度。</p>

      <p>2. 要求您限期纠正违约行为。</p>

      <p>3. 中止或终止向您提供“点点平台”服务或其他相关服务。</p>

      <p>4. 宣布本协议及“点点平台”服务项下未支付的应还款金额提前到期，并要求您提前支付全部应付款项。</p>

      <p>5. 通知资金方或合作的第三方支付机构在取得您的授权的情况下从您绑定的储蓄卡账户中扣收全部或部分应付款项。如果账户中款项的币种与分期本金发放的币种不同，服务商有权按扣款当日中国人民银行公布的外汇中间价折算成应付款项币种。</p>

      <p>6. 扣划您在服务商或服务商关联公司处的任何应收或留存款项（如有）用以偿还您在服务商处的债务。</p>

      <p>7. 以合法手段追偿应付款项(包括但不限于委托债务催讨公司、律师事务所等其他第三方代为追讨，申请相关部门进行调查、向法院提起诉讼等)，由此引起的一切费用由您承担。</p>

      <p>8. 根据法律法规或本协议约定有权采取的其他违约救济措施。</p>

      <p>第七条 权利和义务</p>

      <p>(一) 用户的权利和义务</p>

      <p>1. 有权要求服务商对您提供的有关信息予以保密，但法律法规另有规定、您予以授权、或本协议另有约定的除外。</p>

      <p>2. 享有服务商对“点点平台”服务所承诺的各项服务，有权监督服务质量，并对不符合质量的服务进行投诉。</p>

      <p>3. 有权知悉“点点平台”服务的功能、使用方法、收费项目、收费标准、适用费率及相关的计算规则。</p>

      <p>4. 向【服务商】提供真实、有效的资料。如迁往异地、工作变动、通讯地址及电话变更、单位名称变更、电子邮箱或身份证件号码变更等，应及时通知服务商，包括但不限于登陆账户修改、书面通知、在线或电话联系客服等。</p>

      <p>5. 仔细阅读并充分理解本协议、重要提示及其他所有相关资料和文件，并持续关注服务商通过网站等方式向您公示的协议修订，以及对上述资料和文件的修改和变更。</p>

      <p>6. 应妥善保管本人的账户名、密码、绑定的手机号码、手机校验码等与服务商有关的一切信息。您应确保不向其他任何人泄露账户信息和密码。对于因密码泄露所致的损失，由您自行承担。如您发现有他人冒用或盗用本人账户及密码或任何其他未经合法授权之情形时，应立即以有效方式通知服务商，要求其暂停相关服务。同时，您理解服务商对相应的请求采取行动需要合理期限，在此之前，服务商对已执行的指令及(或)所导致的您的损失不承担任何责任。</p>

      <p>7. 您了解并同意，“点点平台”与资金方提供上述资金划转服务时可能需要与银行或非银行业的第三方支付机构等开展合作。因此，您确认并同意：“点点平台”和资金方不对银行及第三方支付机构进行相应资金划转的时限、准确性、及时性等作出任何承诺或承担任何相关责任，包括但不限于由此产生的利息、货币贬值、银行及第三方支付机构系统故障、银行及第三方支付机构对资金划转的特定限制等导致的损失或责任。</p>

      <p>8. 您应按时支付“点点平台”服务项下的应付款项。</p>

      <p>9. 您知晓并确认，如逾期向资金方还款的，则众安保险有权在向资金方承担保险责任后向您追偿以下款项（简称“追偿款项”）：</p>

      <p>a) 众安保险理赔的全部款项；</p>

      <p>b) 用户逾期还款产生的逾期利息、逾期违约金；</p>

      <p>c) 众安保险为追偿、催收上述款项所产生的其他一切费用（包括但不限于评估鉴定费、差旅费、诉讼费、执行费、律师费等）。</p>

      <p>10. 按照服务商制订并公布的收费标准支付相关费用。</p>

      <p>11. 如您发生对您财务情况构成威胁或对您履行本协议项下的义务产生不利影响的任何其他事件，包括但不限于涉及或可能涉及经济纠纷、财务状况恶化等，均应在该等情形发生之日起五个工作日内书面通知服务商。</p>

      <p>12. 您声明在接受本协议时本人不存在任何违反法律、法规与规章的行为或情形；若您的上述声明虚假或者上述承诺未被履行，或者您可能发生违法违规风险，服务商有权提前终止本服务或采取本协议约定或法律允许的其他救济措施。</p>

      <p>13. 在您未清偿所有应付款项前，您不得提前终止本协议；且您同意在您未清偿所有应付款项前，若申请变更、注销您的任何一个账户，均应事先征得服务商的同意。</p>

      <p>14. 如您已归还应付款项或以其它方式消除违约情形的，您愿意自行督促服务商及时通知服务商关联公司删除相关违约信息或恢复您与服务商关联公司相关服务协议的履行，以免因服务商关联公司无义务接受来自您的任何通知而造成您的困扰。</p>

      <p>(二) 服务商的权利和义务</p>

      <p>1. 对不遵守有关法律法规、本协议等规定的用户(包括但不限于用户未在规定期限内支付应付款项的)或者服务商有理由认为用户不再符合“点点平台
        ”服务的使用条件时，服务商有权基于合理怀疑拒绝用户继续使用“点点平台”进行付款，并由“点点平台”以本协议中规定方式提醒您，如您在合理期限内未向服务商提供充分证据以消除该等合理怀疑的，服务商有权提前暂停“点点平台”服务而不必事先通知您本人。您对服务商网站停止其“点点平台”服务的使用有异议的，需要按照服务商的要求，依据服务商网站所提供的用户服务等方式向服务商提供充分证据以消除该等合理怀疑，具体异议提出方式及解决方式以服务商不时发布和更新的规则约定为准。</p>

      <p>2. 服务商保留对您收取费用的权利，且有权在有关法律法规允许的范围内，结合“点点平台”业务发展等实际情况，不时地维护和更新“点点平台”服务的适用范围、各项使用功能、服务范围和收费标准，并以本协议约定的方式及时通知您。</p>

      <p>3. 服务商将根据行业规则、国家相关法律法规及业务发展情况为您提供相关的优惠活动或服务，活动或服务规则以届时服务商相关页面公布的内容为准。</p>

      <p>4. 服务商将通过服务商网站公告、站内消息、电子邮件、手机短信等您在服务商网站已经认可的信息推送方式向您公示和/或告知以下信息和通知：</p>

      <p>a) 新的服务、机会以及优惠信息；</p>

      <p>b) “点点平台”服务的适用范围、各项使用功能、服务范围和收费标准，以及其不时地修订和更新；</p>

      <p>c) 本协议有关的服务信息、重要提示、协议文件；</p>

      <p>d) 其他与本协议有关的信息和通知。</p>

      <p>5. 服务商有义务接受您对于“点点平台”服务相关信息的查询服务。服务商有建立针对“点点平台”服务的公平、有效的投诉制度的义务，并公开投诉程序和投诉电话。对您关于账务情况的查询和改正要求给予答复。</p>

      <p>6. 服务商对您的个人身份信息以及与您有关的银行卡等数据(以下简称“保密信息”)有权予以保留，服务商对该等保密信息负有保密的义务，除与履行本协议有关的合作公司、或出于为您提供更好的服务目的以外，未经您的允许，服务商不得擅自将该等保密信息以任何形式披露给第三方，但根据相关法律法规需予以披露或者依据本协议的规定使用、披露用户信息的除外(包括：服务商对您的违约情形进行违约救济，服务商向人行征信系统提供用户相关信息等情形)。</p>

      <p>7. 服务商有权采取以下措施督促您尽快履行还款义务，包括但不限于将您列入其及其合作方所对接的征信系统黑名单、通过您提供的信息进行催收、通过第三方合作机构催收借款等。</p>

      <p>第八条 用户信息的提供、收集、使用</p>

      <p>您同意按照以下要求提供基本信息：</p>

      <p>1.您的基本信息的收集范围以“点点平台”服务实名认证的要求为准。您应及时提供申请服务所需的各项信息，并应确保提供的信息真实、完整、准确。</p>

      <p>2. 如因您违反上述规定，提供的信息不真实、不完整、不准确、不及时，所造成的一切损失和责任由您承担，服务商有权立即停止为您提供服务并视情况限制或禁止您使用本产品的全部或部分功能。</p>

      <p>3. 您同意授权服务商收集、保存、使用、管理、披露您的个人资料、信息、档案（包括但不限于您的个人身份证信息、联系地址、联系方式、学历信息、历史交易记录、信贷信息等），同意授权服务商和通过其合作的第三方机构核实该等资料和记录（包括但不仅限于人行征信、腾讯征信、芝麻信用等）。</p>

      <p>4. 您同意服务商按照如下规则使用及公开您的信息：</p>

      <p>a) 为促成您与服务商签署本协议之目的，服务商有权在相互之间互通和共享您的信息，以便在作出是否签署本协议、确定具体承保额度或是否向您提供或终止服务的决定时参考。</p>

      <p>b) 如您违反本协议约定，服务商有权在相互之间使用您的信息以向您催收债务；同时服务商有权将您的逾期信息在不违反中国法律的情况下向第三方合作机构提供，以促使您履行本协议。</p>

      <p>c) 在行政、司法等政府机构要求时，服务商可向此类机构提供您的信息。例如涉及“反洗钱”要求的，服务商可根据此类机构的要求提供用户的身份证复印件及其他身份识别文件。</p>

      <p>d) 服务商按照本条规定使用您信息的，无需对因获取、使用、公开您信息而给您造成的任何损失承担独立的或连带的赔偿责任，包括但不限于因服务商或第三方合作机构的不当使用您信息的行为给您造成的任何损失。</p>

      <p>第九条 通知和送达</p>

      <p>(一) 通知</p>

      <p>除法律法规或监管规定另有强制性规定外，本协议履行过程中，服务商传递给您的书面通知，按照您向服务商提供的通讯地址交邮后的第三个自然日即视为送达；书面通知的形式还包括但不限于在服务商公告、向您发送电子邮件、站内消息、手机短信和传真等电子方式，在采用电子方式进行书面通知的情况下发送当日即视为送达。</p>

      <p>(二) 司法文书送达</p>

      <p>对于因本协议引起的任何诉讼中的司法文书(包括但不限于诉讼文书)，同意司法机关通过向您在本协议中约定的指定账户中留存的通讯地址和/或手机号码送达法律文书和/或发送短信的方式予以送达，司法机关向前述通讯地址和/或手机号码发出法律文书和/或短信当日即视为送达，且上述送达方式适用于各个司法阶段，包括但不限于一审、二审、再审、执行以及督促程序。</p>

      <p>(三) 通讯地址和信息</p>

      <p>您确认及保证通讯地址和信息是真实、准确、有效的。若您的送达地址有变更，您有义务及时告知服务商和/或司法机关变更后的送达地址。如果提供的通讯地址和信息不确切，或未能及时告知变更后的通讯地址和信息，您自行承担由此可能产生的法律后果。</p>

      <p>第十条 免责条款</p>

      <p>(一) 免责</p>

      <p>服务商网站及与提供“点点平台”服务相关平台的信息系统出现下列任一状况而无法正常运作，致使无法向您提供本协议项下的各项服务，服务商不承担任何违约或赔偿责任，该状况包括但不限于：</p>

      <p>1. 在“点点平台”服务网站维护期间；</p>

      <p>2. 电信设备出现故障不能进行数据传输的；</p>

      <p>3. 因台风、地震、海啸、洪水、停电、战争、恐怖袭击等不可抗力之因素，造成系统障碍不能执行业务的；</p>

      <p>4. 由于黑客攻击、电信部门和其他服务商有信息技术依赖的相关部门、企事业单位技术调整或故障、网站升级、银行方面的问题等原因而造成的服务中断或者延迟。</p>

      <p>(二) 法律、政策变更</p>

      <p>本协议有效期内，因国家相关主管部门颁布、变更的法令、政策导致服务商不能提供约定服务的，不视为其违约，各方可根据相关的法令、政策变更协议内容或提前终止本协议，在此情况下，您已经使用“点点平台”服务而尚未到期或偿还的任何款项(包括服务费和其他费用)，视为立即到期，您应立即归还，否则服务商仍有权按照本协议的约定采取合理的救济措施。</p>

      <p>第十一条 协议变更、解除、终止和权利义务的转让</p>

      <p>(一) 协议变更与解除</p>

      <p>1. 您在此不可撤销地同意，服务商有权随时单方面修改或新增本协议及其有关法律文件中与您之间相关的权利义务，并及时以网站公告的方式通知您。经修订的协议自服务商发布网站公告之日起立即生效。若您不同意修改本协议，则应当立即停止使用“点点平台”服务并在服务商要求的期限内全额支付本协议项下全部应付款项；否则，视为您同意并接受修改后的协议。</p>

      <p>2. 本协议生效后，除另有书面约定外，您不得要求单方擅自变更或解除本协议。服务商有权基于自身经营考虑，因任何理由随时宣布中断、终止本协议或其任何部分，并要求您在指定期限内支付本协议项下全部应付款项。</p>

      <p>(二) 服务终止</p>

      <p>您在使用“点点平台”服务的过程中，如果有下列情形发生，您同意服务商有权终止提供服务，您应立即支付所有到期和未到期的应付款项：</p>

      <p>1. 您主动关闭“点点平台”服务；</p>

      <p>2. 您个人账户被注销；</p>

      <p>3. 冒用他人名义、盗用他人账户使用“点点平台”服务；</p>

      <p>4. 您违反本协议或与本协议相关的任何规范性文件的约定导致本协议中约定的违约情形出现的；</p>

      <p>5. 从事司法机构、监管机构等认为违法违规的交易行为，或“点点平台”服务提供方认定的不适当交易行为；</p>

      <p>6. 除上述原因外，服务商有权根据风险及自身业务运营情况需要随时中止或终止向您提供“点点平台”服务，因此导致您无法使用服务或服务受到限制的，不视为“点点平台”服务提供方违约，在此情况下，您已经使用“点点平台”服务而尚未到期或偿还的任何款项(包括本金、逾期违约金和其他费用)，视为立即到期，应立即归还。</p>

      <p>(三) 权利义务的转让</p>

      <p>未经服务商事先书面同意，您不得将本协议项下的权利和义务全部或部分地转让给任何第三方。服务商有权将其在本协议项下的权利和义务全部或部分转让给第三方，且转让行为无须征得您的同意，服务商将书面通知您该等转让行为。</p>

      <p>第十二条 附则</p>

      <p>(一) 争议解决</p>

      <p>因本协议引起的或与本协议有关的争议，您可与服务商协商解决。协商不成的，任何一方均有权提交上海仲裁委员会以仲裁的方式进行解决。</p>

      <p>(二)其他</p>

      <p>本协议未尽事宜，以相关法律法规及修改或新增的相关协议、“点点平台”服务项下服务商委托的第三方的相关服务协议及其他平台规则约定为准。</p>

      <p>点点会员服务协议</p>

      <p>欢迎注册成为点点会员，为保障您的合法权益，请您在注册前仔细阅读本服务协议的所有内容，尤其注意以粗体格式标注的内容。如果您不同意本服务协议的任何内容或者无法准确理解协议条款的含义，请不要进行后续操作。如果您同意本协议的所有内容，请勾选“我已经认真阅读并同意《点点会员服务协议》，当您点击“同意”按钮即表示您确认本服务协议内容并自愿遵守本协议。</p>

      <p>一、会员须知</p>

      <p>1.注册者资格</p>

      <p>您确认，您在点点网站、APP以及微信公众号/服务号(以下简称“点点”或者平台方)上完成注册程序或使用点点服务时，您应当是具备完全民事行为能力的自然人。若您不具备前述主体资格，则您的监护人应承担因此而导致的一切后果。</p>

      <p>您可以注册成为点点会员，但在接受或购买点点平台上展示的具体产品或服务时，根据法律法规要求及产品或服务所需，您可能需要提供必要的身份信息及资料。您特此授权点点根据《点点隐私政策》收集和使用您的个人信息及资料。</p>

      <p>2.用户信息</p>

      <p>a). 在完成注册、激活或验证流程时，您应当按照相应页面的提示提供您的真实、准确、完整的身份信息及资料；</p>

      <p>b). 当您的身份信息及资料发生变化时，您应当及时进行更新。</p>

      <p>3.隐私政策</p>

      <p>您了解并同意，点点将按照《点点隐私政策》保护您的个人信息，点点 将在网站、APP以及微信公众号/服务号等公布并有权不时修订《点点隐私政策》，《点点隐私政策》构成本协议的有效组成部分。</p>

      <p>4.账户安全</p>

      <p>a).您须对您的登录名和密码下发生的所有活动（包括但不限于发布信息、网上点击同意或提交购买、接受各类产品或服务等）承担法律责任；</p>

      <p>b). 您了解并同意：您须妥善保管您在点点的登录名及密码，若因您的自身原因导致用户资料信息及密码泄露，点点不承担任何责任。如发现任何人未经授权使用您的点点登录名和密码，您应当立即通知点点，授权点点经过必要身份识别措施后更改密码或作出其他应对措施。但点点不会对因您未能遵守本款规定而产生的任何损失承担法律责任。</p>

      <p>5.账户管理</p>

      <p>除非有法律规定或司法裁判，否则您的登录名和密码不得以任何方式转让、赠与或继承。</p>

      <p>二、会员的权利和义务</p>

      <p>1.在遵守本服务协议的前提下，您将享有本网站提供的会员服务，并将收到点点平台发布的最新的优惠产品和服务的相关信息。</p>

      <p>2.如您不愿意接受点点的信息，您有权要求点点停止向您发送产品和服务信息。</p>

      <p>3.在使用点点服务过程中，您承诺遵守以下约定：</p>

      <p>a). 在使用点点服务过程中所有行为均遵守国家法律、法规等规范性文件，不违背社会公共利益或公共道德，不损害他人合法权益，不违反本协议；</p>

      <p>b). 在未经点点事先书面同意的情况下，不以复制、传播等任何方式使用点点网站、APP以及微信公众号/服务号上展示的资料、信息或数据。</p>

      <p>4.1. 您了解并同意：</p>

      <p>a). 对于您在点点上发布的涉嫌违法或涉嫌侵犯他人合法权利或违反本协议的信息，点点有权不经通知您即予以删除；</p>

      <p>b). 对于您涉嫌违反承诺的行为对任意第三方造成损害的，您均应当以自己的名义独立承担所有的法律责任。</p>

      <p>三、点点商城服务条款</p>

      <p>1. 点点商城服务条款是点点商城与您就商城网站服务等相关事宜所订立的契约，请您仔细阅读相关服务条款。</p>

      <p>2. 您同意点点商城拥有通过邮件、短信电话等形式，向在点点商城注册、购物的用户、收货人发送订单信息、促销活动等告知信息的权利。</p>

      <p>3. 点点商城上的商品价格、数量、是否有货等商品信息随时都有可能发生变动，点点商城不作特别通知。由于网站上商品信息的数量极其庞大，虽然点点商城会尽最大努力保证您所浏览商品信息的准确性，但由于众所周知的互联网技术因素等客观原因存在，点点商城网页显示的信息可能会有一定的滞后性或差错，对此情形您知悉并理解；欢迎纠错，并会视情况给予纠错者一定的奖励。为表述便利，商品和服务简称为"商品"或"货物"。</p>

      <p>4.在您下订单时，请您仔细确认所购商品的名称、价格、数量、型号、规格、尺寸、联系地址、电话、收货人等信息。收货人与用户本人不一致的，收货人的行为和意思表示视为用户的行为和意思表示，用户应对收货人的行为及意思表示的法律后果承担连带责任。</p>

      <p>5.除法律另有强制性规定外，您了解并同意：点点商城上展示的商品和价格等信息仅仅是要约邀请，您下单时须填写您希望购买的商品数量、价款及支付方式、收货人、联系方式、收货地址（合同履行地点）、合同履行方式等内容；系统生成的订单信息是计算机信息系统根据您填写的内容自动生成的数据，仅是您向点点商城发出的合同要约；点点商城收到您的订单信息后，只有在点点商城将您在订单中订购的商品从仓库实际直接向您发出时（
        以商品出库为标志），方视为您与点点商城之间就实际直接向您发出的商品建立了合同关系；如果您在一份订单里订购了多种商品并且点点商城只给您发出了部分商品时，您与点点商城之间仅就实际直接向您发出的商品建立了合同关系；只有在点点商城实际直接向您发出了订单中订购的其他商品时，您和点点商城之间就订单中该其他已实际直接向您发出的商品才成立合同关系。您可以随时登录您在点点商城注册的账户，查询您的订单状态。</p>

      <p>6.由于市场变化及各种以合理商业努力难以控制的因素的影响，点点商城无法保证您提交的订单信息中希望购买的商品都会有货；如您拟购买的商品，发生缺货，您有权取消订单。</p>

      <p>7.点点商城将会把商品（货物）送到您所指定的收货地址，所有在点点商城上列出的送货时间为参考时间，参考时间的计算是根据库存状况、正常的处理过程和送货时间、送货地点的基础上估计得出的。</p>

      <p>8. 因用户提供的信息错误或地址不详细、货物送达后无人签收、情势变更因素、自然灾害及交通戒严等不可抗力因素造成订单延迟或无法配送等，点点商城不承担延迟配送的责任。</p>

      <p>四、责任免除</p>

      <p>1.您了解并同意，点点不对因下述任一情况而导致您的任何损害承担责任：</p>

      <p>a). 使用或未能使用点点的服务；</p>

      <p>b). 第三方未经批准使用您的账户或更改您的数据；</p>

      <p>c). 你接受或购买的发布在点点平台上的产品或服务条款或协议中约定的免责范围，以及约定的服务范围之外的损失。</p>

      <p>2.在任何情况下，点点均不对由于信息网络正常的设备维护，信息网络连接故障，电脑、通讯或其他系统的故障，电力故障，罢工，暴乱，起义，骚乱，火灾，洪水，风暴，爆炸，战争，政府行为，司法行政机关的命令或第三方的不作为而造成的不能服务或延迟服务承担责任；</p>

      <p>3.为了提高服务质量，点点可能暂停服务以调整或升级系统，点点需在网站公告暂停服务时间。在任何情况下，点点无须为暂停会员服务承担违约责任。</p>

      <p>五、服务协议的修改、中止、终止和账户注销</p>

      <p>1.您了解并同意：点点在法律环境变化或业务发展需要时可能对本服务协议所做的修改，本服务协议如发生任何变动，点点将在网站上公示变动内容，如您不同意相应修改的，可以选择注销您的点点会员账户。</p>

      <p>2.您同意，出现以下情况时，点点有权不经事先通知地中止、终止向您提供部分或全部点点的会员服务，并注销您的账户（点点会员资格），且无须为此向您或任何第三方承担任何责任：</p>

      <p>a). 您在使用点点平台提供的服务期间存在违法行为或违反本协议和/或规则的行为的；</p>

      <p>b). 您提供的个人身份信息虚假或不真实或不完整或过期无效的；</p>

      <p>c). 以他人名义注册为点点会员的；</p>

      <p>d). 未经有效许可使用他人银行账户进行支付的；</p>

      <p>e). 经证实用户为政府部门发布的恐怖分子或被列入其他黑名单；</p>

      <p>f). 存在其他违反诚实信用或欺诈行为的；</p>

      <p>g). 本协议变更时，您明示并通知点点不愿接受新的服务协议的；</p>

      <p>h). 您连续三年未登录过点点平台的；</p>

      <p>i). 其它点点认为应当终止服务的情况。</p>

      <p>3.您的会员服务被中止、终止或者账户被注销后，点点根据您的授权有权继续保存您在点点服务期间的所有交易信息。</p>

      <p>4.点点中止或终止向您提供点点平台上的服务或注销您的账户后，对于您在服务中止或终止之前接受或购买的点点平台上的产品和服务，点点仍将按产品或服务所对应具体协议或约定履行。</p>

      <p>六、法律适用、管辖与其他</p>

      <p>1. 本协议适用中华人民共和国大陆地区法律。</p>

      <p>2. 如因本协议产生之争议，您同意以被告住所地人民法院为第一审管辖法院。</p>

      <p>3. 本协议包含了您成为点点会员所需要了解并遵守的协议条款，您在购买或接受点点平台上某产品或服务时还需要了解并签署该特定产品或服务的条款或具体约定（请参见您接受该产品或服务时签署的其他协议）。</p>

      <p><b>点点隐私政策</b></p>

      <p><b>概述和声明</b></p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">本政策适用于您访问点点网站（https://www.diandian.com.cn）及移动互联网应用程序APP（名称可能为点点或点点加其他后缀名称）、小程序、微信公众号时，点点为您提供的各项服务和产品，如网上购物、消费金融咨询服务、生活娱乐服务、第三方服务等各项产品或服务。</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">您知晓点点（亦可简称为“我们”）将因国家法律法规、有关规范性文件及政策的规定和经营需要可能会不时的调整上述服务或者产品的具体营销推广名称，但是不因此影响点点提供的服务和产品类型的认定。</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">您在使用点点所提供的产品或服务前，务必仔细阅读本隐私政策，您需在充分理解并同意本隐私政策后，再使用相关产品或服务。您知晓并理解点点将不断优化、迭代或新增为您提供的产品或者服务，点点将据此不时更新本隐私政策，为保障您的个人信息权利，请您及时查阅最新版本的隐私政策。一旦您开始使用点点提供的产品或服务，即表示您已充分理解并同意本隐私政策及更新版。</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">点点的运营者为：深圳蜂点科技有限公司</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">注册地址：深圳市南山区南山街道南海大道西桂庙路北阳光华艺大厦1栋4楼4D16</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">如您有任何疑问、意见或者建议，请通过以下方式和我们联系：</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">客服电话：4000666122（周一到周日9:00-18:00）</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">为便于您了解本隐私声明内容，您可以根据以下提纲阅读相应章节</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">1.我们如何收集和使用您的个人信息</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">2.我们如何使用Cookie和同类技术</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">3.我们如何共享、转让、公开披露您的个人信息</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">4.我们如何保护您的个人信息</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span
              style="">5.您的权利</span></p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">6.我们如何处理儿童的个人信息</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">7.您的个人信息不存在全球范围内转移</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">8.本政策如何更新</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">9.如何联系我们</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">点点深知个人信息对您的重要性，并会竭尽全力保护您的个人信息安全可靠。我们致力于维持您对我们的信任，恪守以下原则，保护您的个人信息：权责一致原则、目的明确原则、选择同意原则、最少够用原则、确保安全原则、主体参与原则、公开透明原则等。同时，我们承诺将按照业界成熟的标准，采取相应的安全措施来保护您的个人信息。</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">一．我们如何收集和使用您的个人信息</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span
              style="">（一）定义</span></p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">个人信息：是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">匿名化：通过对个人信息的技术处理，使得个人信息主体无法被识别，且处理后的信息不能被复原的过程。个人信息经匿名化处理后所得信息不属于个人信息。</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">去标识化：通过对个人信息的技术处理，使其在不借助额外信息的情况下，无法识别个人信息主体的过程。</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">（二）点点会出于本政策所述的以下目的，收集和使用您的个人信息。</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">1.注册成为点点用户</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">您注册成为点点用户，是使用点点为您提供服务或产品的前提，若您不注册成为点点用户，将无法登陆点点页面，并浏览或查看点点产品或服务。</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">为完成账号创建，您需提供以下信息：手机号、短信验证码、创建的登录密码。</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">您提供的上述信息，将在您使用本服务期间持续授权我们使用。在您按照约定注销账号时，我们将停止使用并删除上述信息。</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">2.为您提供网上购物服务</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">您使用点点进行网上购物服务时，需提供您的订单信息（如收件人姓名、手机号、地址信息等）、产品信息（如名称、型号、规格、价款等）、银行卡号等支付账户信息。您提供的上述信息将用来为您提供产品推荐、下单、完成支付、配送、售后、订单信息查询等服务。</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">若您在网上购物时，选择分期付款服务，点点将协助第三方为您提供分期服务，您明确知晓，你需按照操作页面指引，在“支付宝-花呗”的第三方页面完成分期服务申请。您在第三方操作页面的任何信息，除非获得您的书面授权，点点不会访问、收集、留存或做任何形式的信息处理。</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">您提供的上述信息，将在您使用本网上购物服务期间持续授权我们使用。在您按照约定注销账号时，我们将停止使用并删除上述信息。</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">3.为您提供消费金融咨询服务</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">您使用点点上的消费金融服务时，如贷款业务、点点闪付服务等，需提供下列信息：</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">3.1 您在办理贷款业务时，需提供您的个人基本信息，如姓名、手机号、身份证号、住址、学历、设备信息、手机定位信息、手机通讯录信息，并需提供身份证件影印件、银行卡号进行实名认证，并按照要求进行人脸识别进行身份验证。您还将在具体贷款申请流程中提供其他您的个人信息以用于完成贷款服务如性别、年龄、职业、贷款用途，具体以借款申请页面展示的信息为准，并于贷款申请过程中产生借款期限、授信额度、借款额度、借款使用情形等借款信息。</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">您明确知晓，上述信息将用于贷款方/出借方及担保方、保险人及咨询服务方等贷款业务直接相关方或受托方，对您进行贷款申请受理、贷款审核、风险审核之用（如判断该申请行为是否为您本人操作、您的信用状况评级等）以及在业务存续期间持续的为您提供贷后、保后、支付、查账还款等管理服务。</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">您明确知晓您的姓名、手机号、身份证号、银行卡号、工作单位贷款情况、还款情况、投保情况、保险赔付情况等信息将可能被以加密方式提供给金融信息基础数据库、经批准合法成立的综合信息用服务机构、企业征信机构等合法成立的大数据服务机构用来收集相关机构合法储存并有权提供的您的相关信用信息或评价结果。</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">您提供的上述信息，将在您使用本金融咨询服务期间持续授权我们使用。在您按照约定注销账号时，我们将停止使用并删除上述信息。</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">3.2 您在使用点点的闪付服务时，需提供您的姓名、身份证号、银行卡号和该卡对应的银行预留手机号。您明确知晓，上述信息将用于闪付服务申请时的实名认证和风险审核之用以及服务期间持续为您提供线下支付、线上查账等服务。</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">您提供的上述信息，将用于闪付服务期间持续授权我们使用。在您按照约定注销账号时，我们将停止使用并删除上述信息。</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">4.生活娱乐服务</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">为使用点点的生活娱乐服务，如小游戏、营销活动等，通过完成点点任务赚取奖励金、积分、需提供您的手机号、身份证号信息用于实名认证和积分获取和消费。</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">您提供的上述信息，将在您使用本生活娱乐服务期间持续授权我们使用。在您按照约定注销账号时，我们将停止使用并删除上述信息。</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">5、第三方服务</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">点点为您展示合作的第三方提供的服务或产品，如银联云闪付、信用卡办理、保险产品、充值缴费、信用报告、人脸识别、银行卡鉴权、身份证验证、消息推送、分享等。您明确知晓</span><span
              style="">点点仅为该产品最终提供方的技术服务提供方，您的申请行为除通过点点外，还将通过在该第三方页面完成，并提供给第三方您在该页面提供的信息，依据您和第三方的约定进行。</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">若我们要将信息用于本政策未载明的其他用途时，会事先征求您的授权。</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">当我们要将基于特定目的收集的信息用于其他目的时，会事先征求您的同意。</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">6、个性化推荐</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">点点可能会根据您的浏览及搜索记录、设备信息、位置信息、网络身份标识，提取您的浏览、搜索偏好、行为习惯、位置信息等特征数据进行用户画像，为您提供个性化推荐服务，即点点页面上为您展示符合您画像的产品或服务信息。点点承诺不会将您的画像用于其他用途。您可以告知我们您希望退出或暂时关闭为您提供个性化展示、推荐的服务。</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">7、在您使用服务过程中收集的信息</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">为向您提供更契合您需求的页面展示和搜索结果、了解产品适配性、识别账号异常状态，点点会收集关于您使用的服务以及使用方式的信息并将这些信息进行关联，这些信息包括：</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">设备信息：点点会根据您在软件安装及使用中授予的具体权限，接收并记录您所使用的设备相关信息（例如设备型号、操作系统版本、设备设置、唯一设备标识符等软硬件特征信息）、设备所在位置相关信息（例如IP地址、GPS位置以及能够提供相关信息的Wi-Fi接入点、蓝牙和基站等传感器信息）。</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">日志信息：当您使用点点官网或移动应用程序提供的产品或服务时，点点会自动收集您对点点服务的详细使用情况，作为有关网络日志保存。例如您的搜索查询内容、IP地址、浏览器的类型、电信运营商、使用的语言、访问日期和时间及您访问的网页记录等。</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">请注意，单独的设备信息、日志信息等是无法识别特定自然人身份的信息。如果点点将这类非个人信息与其他信息结合用于识别特定自然人身份，或者将其与个人信息结合使用，则在结合使用期间，这类非个人信息将被视为个人信息，除取得您授权或法律法规另有规定外，点点会将就该类个人信息做匿名化、去标识化处理。</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">当您与点点联系时，点点可能会保存您的通信/通话记录和内容或您留下的联系方式等信息，以便与您联系或帮助您解决问题，或记录相关问题的处理方案及结果。</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">上述使用您信息的方式，可能会向您发送推介信息，对您进行信用评估，将您的不良信息报送金融基础信息数据库、中国互联网金融协会、征信机构、第三方合作机构等，建议您维持良好的个人征信记录信息，及时还款，支付息费。</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">二、我们如何使用使用Cookie或同类技术</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">为使您获得更为轻松的访问体验，您访问点点官网、移动应用程序或使用点点提供的产品或服务，点点可能会通过采用各种自动数据收集工具对您的相关信息进行收集、保存、使用等方式处理，包括但不限于您的网络信息、设备标识符、硬件型号、操作系统版本、您的位置、软件使用习惯、以及与点点的服务相关的日志信息、浏览记录等。自动数据收集服务是为了识别您的身份、解您的使用习惯，帮您省去重复输入注册信息的步骤，帮助判断您的帐户安全等。这些数据可能是Cookie、Flash Cookie，或您的浏览器或关联应用程序提供的其他本地存储。</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">（一）Cookie</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">请您理解，我们的某些服务只能通过使用Cookie才可得到实现。如您的浏览器或浏览器附加服务允许，您可以修改对Cookie的接受程度或者拒绝点点的Cookie。多数浏览器工具条中的“帮助”部分会告诉您怎样防止您的浏览器接受新的Cookie，怎样让您的浏览器在您收到一条新Cookie时通知您或者怎样彻底关闭Cookie。此外，您可以通过改变浏览器附加程序的设置，或通过访问提供商的网页，来关闭或删除浏览器附加程序使用的Flash Cookie及类似数据。但这一举动在某些情况下可能会影响您安全访问和使用点点提供的服务。</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">（二）限制自动采集信息工具的方法：</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">安卓手机：进入设置-应用程序管理，选择点点app，储存-删除数据，即可清空缓存信息。</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">苹果手机：进入设置，选择应用管理，选择点点app，删除应用后重装，即可清空缓存信息。</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">三、我们如何共享、转让、公开披露您的个人信息</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span
              style="">（一）共享</span></p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">点点不会与任何公司、组织和个人分享您的个人信息，但以下情况除外：</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">1、在获取明确同意的情况下共享：根据本隐私政策、与您签署的用户注册协议、页面展示或其他方式的约定，获取了您同意的情况下，点点会与其他方共享您的个人信息；</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">2、在法定情形下的共享：点点可能会根据法律法规、规章、行政规范性文件、行业自律组织文件、诉讼争议解决需要、资产处置需要，或按行政、司法机关依法提出的要求，对外共享您的个人信息；</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">3、与授权合作伙伴共享：仅为实现本隐私政策中约定的目的，点点在某些必要情形下可能与合作伙伴共享您的个人信息。例如，某些服务和（或）产品由我们的合作伙伴提供或由我们与合作伙伴、供应商共同提供或委托第三方提供。点点仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。点点的合作伙伴无权将共享的个人信息用于与产品或服务无关的其他用途。</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">对点点与之共享个人信息的公司、组织和个人，点点会与其签署严格的数据保护协定，要求他们按照点点的说明、本隐私政策以及其他任何相关的保密和安全措施来处理个人信息。</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span
              style="">（二）转让</span></p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">点点不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外:</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">1、在获取明确同意的情况下转让：获得您的明确同意后，点点方可向其他方转让您的个人信息；</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">2、在涉及合并、收购、资产转让或类似的交易时，如涉及到个人信息转让，点点会要求新的持有您个人信息的公司、组织继续受本隐私声明的约束，否则,点点将要求该公司、组织重新向您征求授权同意。</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">（三）公开披露</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">点点仅会在以下情况下，公开披露您的个人信息：</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">1、在获取您明确同意或基于您的主动选择，点点可能会公开披露您的个人信息；</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">2、应政府部门、监管机构或司法机关依据法律法规或监管规定的要求而披露。</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">（四）共享、转让、公开披露个人信息时事先征得授权同意的例外</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">以下情形中，共享、转让、公开披露您的个人信息无需事先征得您的授权同意：</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">1、与国家安全、国防安全有关的；</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">2、与公共安全、公共卫生、重大公共利益有关的；</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">3、与犯罪侦查、起诉、审判和判决执行等有关的；</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">4、出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">5、您自行向社会公众公开的个人信息；</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">6、从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">根据法律法规规定，共享、转让、公开披露经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别个人信息主体的，不属于个人信息的对外共享、转让及公开披露行为，对此类数据的保存及处理将无需另行向您通知并征得您的同意。</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">四、我们如何保护您的个人信息</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">1、我们已使用符合业界标准的安全防护措施保护您提供的个人信息， 防止数据遭到未经授权访问、公开披露、使用、修改、损坏或丢失。我们会采取一切合理可行的措施，保护您的个人信息。例如，在您的浏览器与“服务”之间交换数据(如信用卡信息)时受 SSL 加密保护；我们同时对点点的app和网页提供 https安全浏览方式；我们会使用加密技术确保数据的保密性；我们会使用受信赖的保护机制防止数据遭到恶意攻击；我们会部署访问控制机制，确保只有授权人员才可访问个人信息;以及我们会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">2、我们会采取一切合理可行的措施，确保未收集无关的个人信息。我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非需要延长保留期或受到法律的允许。</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">3、互联网并非绝对安全的环境，而且电子邮件、即时通讯、及与其他点点用户的交流方式并未加密，我们强烈建议您不要通过此类方式发送个人信息。请使用复杂密码，协助我们保证您的账号安全。</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">4、互联网环境并非百分之百安全，我们将尽力确保或担保您发送给我们的任何信息的安全性。如果我们的物理、技术、或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改、或毁坏，导致您的合法权益受损，我们将承担相应的法律责任。</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">5、在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取 的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span
              style="">五、您的权利</span></p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">按照中国相关的法律、法规、标准，我们保障您对自己个人信息行使以下权利：</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">（一）访问您的个人信息</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">您有权访问您的个人信息，法律法规规定的例外情形除外。如果你想行使数据访问权，可以通过以下方式访问：</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">您可以提交书面请求以查阅您的个人信息。</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">（二）更正您的个人信息</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">当您发现我们处理您的个人信息错误或者有任何变动时，您有权要求书面通知我们，要我们</span><span
              style="">更正或者更新。您可以通过以下方式提出更正申请。</span></p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">方式：联系客服电话，提交书面请求。</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">我们将在15天内回复您的更正请求。</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">（三）删除您的个人信息</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">以下情形，您可以向我们提出删除个人信息的请求：</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">1.如果我们处理个人信息的行为违反法律法规</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">2.如果我们收集、使用您的个人信息，却未征得您的同意</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">3.如果我们处理个人信息的行为违反了和您的约定</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">4.如果您不再使用我们的产品或服务，并注销了账号</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">若我们决定响应您的删除请求，我们还将同时通知从我们获得您的个人信息的实体，要求其及时删除。除非法律法规另有规定，或者这些实体取得您的独立授权。</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">当您从我们的服务中删除信息后，我们可能不会立即备份系统中删除相应信息，但会在备份更新时删除这些信息。</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">（四）改变您授权同意的范围</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">4.1每个业务功能需要一些基本的个人信息才得以完成（见本政策“第一部分”）。除非另有约定，对于额外收集的个人信息的收集和使用，您可以随时给予或者收回您的授权同意。</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">4.2 如果您不想接受我们给您发送的商业广告，您随时可以通过手机系统设置关闭APP推送权限进行取消。</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">（五）个人信息主体注销账户</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">您在符合本隐私政策规定的相关条件时，可以注销您的账户，您可以通过如下方式进行操作：联系客服进行注销账户申请，一般情况下，我们会在15日内进行回复。</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">在账户注销之后，我们将停止为您提供产品或服务，并依据您的要求，删除您的个人信息，法律法规另有规定除外。</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">您理解并知晓，您注销账户前需保证您在点点上购买的商品、享受的服务等已终止，且不存在对点点或交易相对方应承担的违约或侵权责任。</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">（六）个人信息主体获取个人信息副本</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">您有权获得您的个人信息副本，您可以通过在点点相关页面的相应功能模块中查找因该业务功能所产生的个人信息副本。</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">（七）约束信息系统自动决策</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">在某些业务功能中，我们可能仅依据信息系统、算法在内的非人工自动决策机制做出决定。如果这些决定显著影响您的合法权益，您有权要求我们做出解释，我们也将提供适当的救济方式。</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">（八）响应您的上述请求</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">为保障安全，点点可能会先要求您验证自己的身份，然后再处理您的请求。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际的请求，点点可能会予以拒绝。</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">在以下情形中，按照法律法规要求，点点将无法响应您的请求：</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">（1）与国家安全、国防安全有关的；</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">（2）与公共安全、公共卫生、重大公共利益有关的；</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">（3）与犯罪侦查、起诉、审判和执行判决等有关的；</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">（4）有充分证据表明个人信息主体存在主观恶意或滥用权利的；</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">（5）响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">（6）涉及商业秘密的。</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">六、我们如何处理儿童的个人信息</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">我们的产品、网站和服务主要面对成年人。如果没有父母或者监护人的同意，儿童不得创建自己的用户账户。</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">对于经父母同意而收集儿童个人信息的情况，我们只会在收到法律允许、父母或及监护人明确同意或者保护儿童所必要的情况下，使用和公开披露此信息。</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">尽管当地法律和习俗对儿童的定义不同，但我们将不满14周岁的任何人均视为儿童。</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">如果我们发现自己在未事先获得可证实的父母的同意的情况下收集了儿童的个人信息，则会设法删除相关数据。</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">七、您的个人信息不在全球范围内转移</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">我们在中华人民共和国境内收集和产生的个人信息，将存储在中华人民共和国境内，不会在全球范围内转移。</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">点点将在本隐私政策所述目的所必须的期间保留您的个人信息，除非法律要求或允许在更长的期间内保留您的个人信息。当您的个人信息超出我们的保存期限后，我们将对您的个人信息进行匿名化处理。</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">八、本隐私政策如何更新</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">点点&amp;quot;隐私政策&amp;quot;体现了我们将按照国家关于个人信息保护有关法律法规保护和管理您个人信息的承诺，为给您提供更好的服务，我们会根据不时修订的相关法规要求更新本&amp;quot;隐私政策&amp;quot;。但未经您明确同意，我们不会削减您依据本隐私政策所应享有的权利。</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">对于重大变化，我们还会提供更为显著的通知，通知方式包括弹窗、通知、推送通知、邮件、短信等任何一种或多种。</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">本政策所指的重大变更包括但不限于：</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">1.我们的服务模式发生重大变化。如处理个人信息的目的、处理个人信息的类型、个人信息的使用方式等。</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">2.我们在股权结构、组织架构等方面发生的重大变化。如业务调整、破产并购等引起所有者变更。</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">3.个人信息的共享、转让、公开披露的主要对象发生变化。</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">4.您参与个人信息处理方面的权利及其行使方式发生重大变化</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">5.我们负责处理信息安全的责任部门、联络方式和投诉渠道发生变化时</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">6.个人信息安全影响评估报告表明存在高风险时。</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">我们的&amp;quot;隐私政策&amp;quot;公布于点点官方网站及移动端，方便您随时查阅，及时了解点点最新的隐私政策。</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">九、如何联系我们</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">如您对本隐私政策或您个人信息的相关事宜有任何问题、意见或建议，任何与您个人信息有关的请求或投诉，以及要求取消您所选取的点点的任何服务，请通过以下方式与我们联系：</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">微信公众号“点点官微”或4000666122（周一到周日9:00-18:00）</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">一般情况下，我们将在15天内进行回复。</span>
      </p>
      <p style=""><span
              style="">&#xa0;</span></p>
      <p style=""><span style="">如您对我们的回复不满意，特别是我们的个人信息处理侵犯您的合法权益，您可以通过法院、行业自律机构、行政监管部门寻求外部救济。</span>
      </p>

    </div>
    <div class="auditing" v-if="isAuditing">
      <h2 class="fwbd mt20 tc txdr">用户服务协议</h2>
      <!-- <div data-header="3" class="mt20 fwbd">运营方：临海市万盛小额贷款有限公司</div> -->
      <p class="fwbd">运营方依据本协议的规定为点点Go app用户提供服务，欢迎注册和使用点点呗的平台服务。</p>
      <div data-header="3"><span class="ql-size-12">一、服务条款的确认及接受</span></div>
      <p><span class="ql-size-10">1、本协议为您与点点Go app（本平台）管理者之间所订立的契约，具有合同的法律效力，请您仔细阅读。如您不同意本服务协议中任意条款，请停止使用本平台的服务。</span></p>
      <p><span class="ql-size-10">2、根据国家法律法规变化及本网站运营需要，本平台有权对本协议条款及相关规则不时地进行修改，修改后的内容一旦以任何形式公布在本网站上即生效，并取代此前相关内容。您知悉并确认，如您不同意更新后的内容，应立即停止使用本平台；如您继续使用本平台，即视为知悉变动内容并同意接受。</span></p>
      <div data-header="3"><span class="ql-size-12">二、服务需知</span></div>
      <p><span class="ql-size-10">您一经注册，即视为您已充分阅读、理解并接受本协议的条款和条件，并自愿签署本协议。本协议具备合同的法律效力。</span></p>
      <div data-header="3"><span class="ql-size-12">三、服务内容</span></div>
      <p><span class="ql-size-10">1、使用本平台的服务，您应具消费的权利能力和行为能力。在购物的同时，即视为您满足上述条件，并对您在申请材料中提供的所有信息的真实性负责。</span></p>
      <p><span class="ql-size-10">2、在您购物时，请您仔细确认商品详情和服务信息。</span></p>
      <p><span class="ql-size-10">3、会员在本平台交易签订的合同才去电子合同的，会员统一授权点点Go 平台代其在第三方数字签约服务平台开通自动签署和数字证书认证功能，用户同意第三方数字证书自动认证功能自动签署线上《销售合同》等电子合同，并认可其法律效力，愿意接受上述电子协议的约束。</span></p>
      <p><span class="ql-size-10">4、本平台提供娱乐、资讯、生活服务等各类外接第三方服务，平台为您与合作服务方提供信息技术服务，您应按照与服务提供方签订的具体服务协议获取服务和付费。</span></p>
      <div data-header="3"><span class="ql-size-12">四、服务费用</span></div>
      <p><span class="ql-size-10">1、当您使用点点Go 平台的付费服务，本平台有权向您收取相关服务费用。当您使用相关付费服务时，认可相关服务费用的收费标准，应当依据服务方签署的相关协议履行缴费义务，否则可能承担违约或赔偿责任。</span></p>
      <p><span class="ql-size-10">2、费用收取时间：本平台的不同服务对应不同的收费标准，具体收费时间以平台显示为准。</span></p>
      <div data-header="3"><span class="ql-size-12">五、用户个人信息保护及授权</span></div>
      <p><span class="ql-size-10">1、您知悉并确认，您在注册帐号或使用本平台的过程中，需要提供真实的身份信息，本平台将根据国家法律法规相关要求，进行基于移动电话号码的真实身份信息认证。若您提供的信息不真实、不完整，则无法使用本网站或在使用过程中受到限制，同时，由此产生的不利后果，由您自行承担。</span></p>
      <p><span class="ql-size-10">2、您在使用本网站某一特定服务时，该服务可能会另有单独的协议、相关业务规则等（以下统称为&ldquo;单独协议&rdquo;），您在使用该项服务前请阅读并同意相关的单独协议；您使用前述特定服务，即视为您已阅读并同意接受相关单独协议。</span></p>
      <div data-header="3"><span class="ql-size-12">六、违约责任</span></div>
      <p><span class="ql-size-10">1、如果本平台发现或收到他人举报投诉您违反本协议约定或存在任何恶意行为的，本平台有权不经通知随时对相关内容进行删除、屏蔽，并视行为情节对违规帐号处以包括但不限于警告、限制或禁止使用部分或全部功能、帐号封禁、注销等处罚，并公告处理结果。</span></p>
      <p><span class="ql-size-10">2、本平台有权依据合理判断对违反有关法律法规或本协议规定的行为采取适当的法律行动，并依据法律法规保存有关信息向有关部门报告等，您应独自承担由此而产生的一切法律责任。</span></p>
      <p><span class="ql-size-10">3、您理解并同意，因您违反本协议或相关服务条款的规定，导致或产生第三方主张的任何索赔、要求或损失，您应当独立承担责任；本平台因此遭受损失的，您也应当一并赔偿。</span></p>
      <p><span class="ql-size-10">4、除非另有明确的书面说明,本平台不对本网站的运营及其包含在本网站上的信息、内容、材料、产品（包括软件）或服务作任何形式的、明示或默示的声明或担保（根据中华人民共和国法律另有规定的以外）。</span></p>
      <div data-header="3"><span class="ql-size-12">七、所有权及知识产权</span></div>
      <p><span class="ql-size-10">本网站所刊登的资料信息（诸如文字、图表、标识、按钮图标、图像、声音文件片段、数字下载、数据编辑和软件），均是本平台或其内容提供者的财产，受中国和国际版权法的保护。本网站上所有内容的汇编是本平台的排他财产，受中国和国际版权法的保护。本网站上所有软件都是本平台或其关联公司或其软件供应商的财产，受中国和国际版权法的保护。</span></p>
      <div data-header="3"><span class="ql-size-12">八、法律管辖适用及其他</span></div>
      <p><span class="ql-size-10">1、本协议的订立、执行和解释及争议的解决均应适用中国法律。如双方就本协议内容或其执行发生任何争议，双方应尽力友好协商解决；协商不成时，应向运营方所在地的人民法院提起诉讼。</span></p>
      <p><span class="ql-size-10">2、如果本协议中任何一条被视为废止、无效或因任何理由不可执行，该条应视为可分的且并不影响任何其余条款的有效性和可执行性。</span></p>
      <p><span class="ql-size-10">3、本协议未明示授权的其他权利仍由本平台保留，您在行使这些权利时须另外取得本平台的书面许可。本平台如果未行使前述任何权利，并不构成对该权利的放弃。</span></p>

    </div>
  </article>
</template>
<script>
  export default {
    data() {
      return {
        isAuditing: false
      }
    },
    beforeRouteEnter(to, from, next) {

      next()
    },
    created() {
      if (this.$route.query.x == 'pointpoint') {
        document.title = '平台授权及协议须知'
        this.isAuditing = true
      } else {
        document.title = '点点平台授权及协议须知'
        this.isAuditing = false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// agreement.vue?7018dc52